import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RemoteActivityService } from '../../../remotes/remote-activity.service';
import { RemoteTaskService } from '../../../remotes/remote-task.service';
import { ActorSplugInfoDialogService } from '../../2-select-activities-step/activity-collection/activity-item/actor-splug-info-dialog.service';
import { SignatureService } from '../signature/signature.service';
import { TaskCollectionService } from '../task-collection.service';
import { ISignatureOptionsData, SignatureOptionsComponent } from './signature-options.component';

@Injectable()
export class SignatureOptionsDialogService {

  private _dialogRef?: MatDialogRef<SignatureOptionsComponent>;


  constructor(
    private readonly _matDialog: MatDialog,
    private readonly _signatureService: SignatureService,
    private readonly _signatureCollectionService: TaskCollectionService,
    private readonly _actorSplugInfoDialogService: ActorSplugInfoDialogService,
    private readonly _remoteTaskService: RemoteTaskService,
    private readonly _remoteActivityService: RemoteActivityService
  ) {

  }

  open() {

    const self = this;
    this._dialogRef = this._matDialog.open<SignatureOptionsComponent, ISignatureOptionsData, any>(
      SignatureOptionsComponent,
      {
        data: {
          signatureService: this._signatureService,
          signatureOptionsDialogService: self,
          signatureCollectionService: this._signatureCollectionService,
          actorSplugInfoDialogService: this._actorSplugInfoDialogService,
          remoteTaskService: this._remoteTaskService,
          remoteActivityService: this._remoteActivityService
        },
        position: {
          bottom: '0rem',
          top: '0rem',
          right: '0rem',

        },
        height: '100%',
        width: '45rem',
      })


  }

  close() {
    this._dialogRef?.close();
  }
}
